<template>
  <el-container>
    <el-main style="width: 100%; height: 100%">
      <div style="margin-bottom: 30px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="item_font">个人设置</el-breadcrumb-item>
          <el-breadcrumb-item
            ><span class="item_font">基础信息</span></el-breadcrumb-item
          >
        </el-breadcrumb>
      </div>
      <div
        style="
          width: 400px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 60px auto;
        "
      >
        <el-form
          id="selectForm"
          style="width: 400px"
          :rules="rules"
          label-position="right"
          label-width="100px"
          :model="form"
        >
          <el-form-item label="登录名:">
            <!-- <el-input v-model="form.name"></el-input> -->
            <span class="item_font">{{ form.loginName }}</span>
          </el-form-item>
          <el-form-item label="昵称:" prop="nickName" required>
            <el-input
              class="item_font"
              v-model="form.nickName"
              @keyup.enter.native="nextInputMessage(2)"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="头像:" ref="uploadElement" prop="logoUrl">
            <div
              class="upload_box"
              style="
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
              "
            >
              <el-input
                v-model="form.logoUrl"
                v-if="false"
                @keyup.enter.native="nextInputMessage(3)"
              >
              </el-input>
              <el-upload
                class="avatar-uploader"
                :action="avatarUrl"
                :headers="myHeaders"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
                accept=".jpg,.jpeg,.png"
                style="margin-bottom: -17px"
              >
                <div
                  style="
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                  "
                >
                  <img
                    v-if="form.logoUrl"
                    :src="form.logoUrl"
                    class="logoUrl"
                  />
                  <i
                    v-else
                    class="el-icon-plus avatar-uploader-icon"
                    style="margin-left: 5px"
                  ></i>
                  <div
                    v-if="!form.logoUrl"
                    class="el-upload__text"
                    style="margin-right: 10px; margin-left: 5px"
                  >
                    设置头像
                  </div>
                </div>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="联系电话:" prop="tel" required>
            <el-input
              class="item_font"
              v-model.number="form.tel"
              @keyup.enter.native="nextInputMessage(3)"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="微信号:" prop="wechatNumber" required>
            <el-input
              class="item_font"
              v-model="form.wechatNumber"
              @keyup.enter.native="nextInputMessage(4)"
            ></el-input>
          </el-form-item>
          <el-form-item label="微信绑定:" v-if="form.wechatState == true">
            <el-button type="text" size="normal" @click="unbindAction"
              >微信号已绑定_点击解绑</el-button
            >
          </el-form-item>
          <!-- <el-form-item label="微信头像:" v-if="form.wechatState == true">
            <img :src="form.imageUrl" class="logoUrl" />
          </el-form-item>
          <el-form-item label="微信昵称:" v-if="form.wechatState == true">
            <el-input class="item_font" v-model="form.wechatNickName" :disabled="true">
            </el-input>
          </el-form-item> -->
          <el-form-item label="QQ号:" prop="qqNumber">
            <el-input
              class="item_font"
              v-model.number="form.qqNumber"
              @keyup.enter.native="nextInputMessage(0)"
            ></el-input>
          </el-form-item>
          <el-form-item label="擅长领域:" prop="areasOfExpertise">
            <el-input
              class="item_font"
              type="textarea"
              v-model="form.areasOfExpertise"
              @keyup.enter.native="nextInputMessage(1)"
            ></el-input>
          </el-form-item>
          <el-form-item style="margin-top: 60px">
            <!-- 						<el-button>取消</el-button> -->
            <el-button type="primary" @click="onSubmit" class="item_font"
              >保存</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-main>
  </el-container>
</template>

<script>
export default {
  data() {
    var validatePhone = (rule, value, callback) => {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    var qqNumber = (rule, value, callback) => {
      if (value.toString().length === 0) {
        callback();
      } else {
        if (!/[1-9]\d/.test(value)) {
          callback(new Error("请输入正确的qq号"));
        } else {
          callback();
        }
      }
    };

    var validateWechatNumber = (rule, value, callback) => {
      if (
        !/^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/.test(this.form.wechatNumber) &&
        !/^1[3456789]\d{9}$/.test(this.form.wechatNumber)
      ) {
        callback(new Error("请输入正确的微信号"));
      } else {
        callback();
      }
    };
    return {
      avatarUrl:
        JSON.parse(localStorage.getItem("siteObj")).webUrl +
        "/manager/fileInfo/pass/upload",
      myHeaders: {
        Authorization: localStorage.getItem("token"),
      },
      form: {
        loginName: "",
        nickName: "",
        logoUrl: "",
        tel: "",
        wechatNumber: "",
        qqNumber: "",
        areasOfExpertise: "",
        wechatState: false,
        wechatNickName: "",
        imageUrl: "",
      },
      rules: {
        tel: [
          {
            required: true,
            message: "联系电话不能为空",
          },
          {
            type: "number",
            message: "联系电话必须为数字",
          },
          {
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        qqNumber: [
          {
            required: false,
            validator: qqNumber,
            trigger: "blur",
          },
        ],
        nickName: [
          {
            required: true,
            message: "昵称不能为空",
          },
        ],
        wechatNumber: [
          {
            required: true,
            message: "微信号不能为空",
          },
          {
            validator: validateWechatNumber,
            trigger: "blur",
          },
        ],
      },
    };
  },

  created() {
    console.log("MyMessage created function");
  },

  mounted() {
    console.log("MyMessage mounted function");
    this.getUserMessage();
  },

  methods: {
    async onSubmit() {
      console.log("MyMessage onSubmit", this.form);
      if (!/^1[3456789]\d{9}$/.test(this.form.tel)) {
        this.$message.error("请输入正确的手机号");
      } else if (
        this.form.qqNumber != "" &&
        !/^[1-9]\d/.test(this.form.qqNumber)
      ) {
        this.$message.error("请输入正确的QQ号");
      } else if (
        !/^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/.test(this.form.wechatNumber) &&
        !/^1[3456789]\d{9}$/.test(this.form.wechatNumber)
      ) {
        this.$message.error("请输入正确的微信号");
      }
      // else if(!/^[1-9]\d/.test(this.form.qqNumber)){
      // 	if(this.form.qqNumber!==''){
      // 		this.$message.error("请输入正确的QQ号")
      // 	}
      else {
        var api = "/manager/user/updateUserMessage";
        const response = await this.util.postRequest({
          url: api,
          method: "POST",
          data: {
            nickName: this.form.nickName,
            logoUrl: this.form.logoUrl,
            tel: this.form.tel,
            wechatNumber: this.form.wechatNumber,
            qqNumber: this.form.qqNumber,
            areasOfExpertise: this.form.areasOfExpertise,
          },
        });
        if (response.resultCode === "10000") {
          const tipMsg = "基础信息修改成功！";
          localStorage.setItem("avatar", this.form.logoUrl);
          console.log("存储头像信息");
          this.$message.success(tipMsg);
          var account = this.util.getLocalAccount();
          account.logoUrl = this.form.logoUrl;
          this.util.setLocalAccount(JSON.stringify(account));
        } else {
          this.$message.error(response.desc);
        }
      }
    },
    handleAvatarSuccess(res, file) {
      this.form.logoUrl = this.util.getLocalImgUrl() + res.data.fileUrl;
      console.log("图片URL", this.form.logoUrl);
      console.log("上传图片成功", res);
      console.log(file);
      // var account = this.util.getLocalAccount()
      // account.logoUrl = this.form.logoUrl
      // this.util.setLocalAccount(JSON.stringify(account))
      // console.log('MyMessage 头像url = ', account)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/png" || "image/jpg" || "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG/PNG/JPEG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    async getWeState() {
      var api = "/manager/weixin/getBindingWechatUser";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });

      console.log("getWeState response = ", response);
      if (response.resultCode == 10000) {
        if (response.data == null) {
          this.form.wechatState = false;
        } else {
          this.form.wechatState = true;
          this.form.imageUrl = response.data.imageUrl;
          this.form.wechatNickName = response.data.wechatNickName;
        }
      } else {
        this.$message.error(response.desc);
      }
    },

    unbindAction() {
      this.$confirm("此操作将解绑微信号登录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.unbindRequest();
        })
        .catch(() => {
          console.log("unbindAction catch");
        });
    },

    async unbindRequest() {
      var api = "/manager/weixin/unBindingWechatUserByCS";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
      });
      if (response.resultCode == 10000) {
        this.form.wechatState = false;
      } else {
        this.$message.error(response.desc);
      }
    },

    async getUserMessage() {
      var api = "/manager/user/getUserMessage";
      const response = await this.util.postRequest({
        url: api,
        method: "POST",
        data: {},
      });

      if (response.resultCode === "10000") {
        this.form.loginName =
          response.data.loginName != null ? response.data.loginName : "";
        this.form.nickName =
          response.data.nickName != null ? response.data.nickName : "";
        this.form.logoUrl =
          response.data.logoUrl != null ? response.data.logoUrl : "";
        this.form.wechatNumber =
          response.data.wechatNumber != null ? response.data.wechatNumber : "";
        this.form.areasOfExpertise =
          response.data.areasOfExpertise != null
            ? response.data.areasOfExpertise
            : "";
        this.form.tel =
          response.data.tel != null ? parseInt(response.data.tel) : "";
        this.form.qqNumber =
          response.data.qqNumber != "" ? parseInt(response.data.qqNumber) : "";

        this.getWeState();

        // for(var key in this.form){
        // 	console.log(response.data[key])
        // 	this.form.[key]=response.data[key]!=null?response.data[key]:""
        // 	this.form.tel = response.data.tel!=null?parseInt(response.data.tel):""
        // 	this.form.qqNumber = response.data.tel!=null?parseInt(response.data.qqNumber):""
        // }
      } else {
        this.$message.error(response.desc);
      }
    },
    nextInputMessage(num) {
      console.log(num);
      var inputs = document.getElementsByTagName("input");
      var textareas = document.getElementsByTagName("textarea");
      console.log(inputs, textareas);
      if (num === 0) {
        textareas[0].focus();
      } else if (num === 1) {
        inputs[0].focus();
      } else {
        inputs[num].focus();
      }
    },
  },
};
</script>

<style scoped="scoped" lang="scss">
.container {
  margin: 50px auto;
  /* background-color: cyan; */
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.header {
  margin-left: 0;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;

  /* height: 70px; */
  cursor: pointer;
  position: relative;
  overflow: scroll;
}

.avatar-uploader .el-upload::-webkit-scrollbar {
  display: none;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 15px;
  color: #8c939d;
  width: 25px;
  height: 15px;
  line-height: 15px;
  text-align: center;
}

.logoUrl {
  width: 40px;
  height: 40px;
  display: block;
}

#selectForm :deep() .el-form-item__label {
  @include change_size($font_size_normal);
  color: red;
}
</style>
